/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
  userId: null,
  userName: null,
  email: null,
  phone1: null,
  phone2: null,
  phone3: null,
  roleSeq: null,
  roleCode: null,
  myMenus: null,
  companySeq: null,
  mainUrl: null,
  companyName: null,
};
